import {APP} from "../Utils/Constants.ts";
function getNameByField(targetField: string) {
  const filterKey = Object.keys(APP.FILTER).find(key => APP.FILTER[key].FIELD === targetField);
  return filterKey ? APP.FILTER[filterKey].NAME : null;
}

function getFieldByName(name: string) {
  const filterKey = Object.keys(APP.FILTER).find(key => APP.FILTER[key].NAME === name);
  return filterKey ? APP.FILTER[filterKey].FIELD : null;
}

function getSortFieldByName(name: string){
  const filterKey = Object.keys(APP.ORDER).find(key => APP.ORDER[key].NAME === name);
  return filterKey ? APP.ORDER[filterKey].FIELD : null;
}

function getSortNameByField(targetField: string){
  const filterKey = Object.keys(APP.ORDER).find(key => APP.ORDER[key].FIELD === targetField);
  return filterKey ? APP.ORDER[filterKey].NAME : null;
}
export const getFiltersFromParams = () => {
  let filters: any = [];
  const params = new URLSearchParams(window.location.search);
  params.forEach((paramValue, key) => {
    if(key==="tri"){
      const field = "sort";
      const value = paramValue.split("-");
      const fieldName = getSortFieldByName(value[0]);
      filters.push({id: field, values: fieldName + " " + value[1]})
    }else if(key==="page"){
      filters.push({id: "page", values: paramValue})
    }else{
      const field = getFieldByName(key);
      filters.push({id: field, values: paramValue.split('_')})
    }
  });
  return filters;
}

export const buildUrlParams = (filters: Filter[]) => {

  const params = new URLSearchParams();

  filters.forEach((element) => {
    if (typeof element.values === 'object' && element.values !== null && !Array.isArray(element.values)) {
      const combinedValue = element.values.id+"-"+element.values.direction
      const name = "tri"
      params.set(name, combinedValue);
    } else {
      if(element.id==="sort"){
        const values = element.values.split(' ')
        const sortName = getSortNameByField(values[0]);
        params.set("tri",sortName+"-"+values[1] )
      }else if(element.id==="page"){
        params.set("page", element.values)
      }else{
        const combinedValue = Array.isArray(element.values) ? element.values.join('_'): element.values;
        const name = getNameByField(element.id);
        if (name) params.set(name, combinedValue);
      }
    }
  })

  const queryString = params.toString();
  const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${queryString}`;

  history.pushState({}, '', newUrl);
}

